import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";

export const BulkUploadResponseTable = ({ csvResponse = [] }) => {
  const columns = [
    {
      accessorKey: "row",
      header: "Row",
    },
    {
      accessorKey: "error",
      header: "Error Message",
      cell: (value) => (
        <span style={{ color: "var(--mca-danger)" }}>{value.getValue()}</span>
      ),
    },
  ];

  const tableInstance = useReactTable({
    columns,
    data: csvResponse,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <div className="mca-help" style={{ margin: "4px 0 10px" }}>
        The following records failed to add due to invalid data.
      </div>
      <div className="mca-table-wrap">
        <table className="mca-table">
          <thead>
            {tableInstance.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id}>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {tableInstance.getRowModel().rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
